import React from "react";
import savariRide from "../assets/portfolio/savariRide.png";
import magnaMen from "../assets/portfolio/magnaMen.png";
import interviewBot from "../assets/portfolio/interviewBot.png";
import beFit from "../assets/portfolio/beFit.png";
import goToTravel from "../assets/portfolio/goToTravel.png";
import babyCare from "../assets/portfolio/babyCare.png";

function Projects() {
  const portfolios = [
    {
      id: 1,
      src: savariRide,
      github: "https://github.com/Gauravshukla82/ambiguous-oven-8467",
      deployed: "https://savariapp.netlify.app/",
      title: "Cab/Ride booking Website",
      description: "Book the ride from any location",
      techStack: "React, Node.js, Express.js, MongoDB, ChakraUI, Google Maps",
    },
    {
      id: 2,
      src: magnaMen,
      github: "https://github.com/Kini99/Magna-Men",
      deployed: "https://magnamen.netlify.app/",
      title: "Clone of DXL website",
      description: "An E-commerce website which sales the product for plus size mens",
      techStack: "HTML, CSS, JavaScript",
    },
    {
      id: 3,
      src: interviewBot,
      github: "https://github.com/Gauravshukla82/Innov8X",
      deployed: "https://candid-kataifi-19e62b.netlify.app/",
      title: "AI based interview bot",
      description: "Online proctored AI based platform for interview preparation",
      techStack: "React, Node.js, Express.js, MongoDB, ChakraUI, TailWind CSS, GPT-3.5",
    },
    {
      id: 4,
      src: beFit,
      github: "https://github.com/mdasriya/moonlit-spoon-3401",
      deployed: "https://befeet.netlify.app/",
      title: "GYM Website",
      description: "Gym website to book membership and buy supplement",
      techStack: "React, Redux, ChakraUI, CSS",
    },
    {
      id: 5,
      src: goToTravel,
      github: "https://github.com/Gauravshukla82/snazzy-cars-9581/tree/main/Unit-2(WEB-101)",
      deployed: "https://spiffy-brigadeiros-a116dc.netlify.app/",
      title: "Clone of MakeMYTrip website",
      description: "Book your flight from origin to destination",
      techStack: "HTML, CSS, JavaScript",
    },
    {
      id: 6,
      src: babyCare,
      github: "https://github.com/Gauravshukla82/handy-bubble-5100/tree/main/my_app",
      deployed: "https://babbycare.netlify.app/",
      title: "Clone of FirstCry",
      description: "E-commerce website sells baby care products and toys",
      techStack: "React, CSS, JavaScript",
    },
    // Add other portfolio objects here
  ];

  return (

    <div
      name="projects"
      id="projects"
      className="bg-gradient-to-b from-gray-800 to-black w-full  min-h-screen text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8 mt-20">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Projects
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolios.map(({ id, src, deployed, github,title,description,techStack }) => (
            <div
              key={id}
              className=" shadow-md shadow-gray-600 rounded-lg project-card"
            >
              <img
                src={src}
                alt=""
                className="rounded-md duration-200 hover:scale-105 p-2"
              />
              <div className="flex items-center justify-center">
                <button className=" w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                  <a href={deployed} className="project-deployed-link" target="_blank">
                    Demo
                  </a>
                </button>
                <button className="px-6 py-3 w-1/2 m-4 duration-200 hover:scale-105">
                  <a href={github} className="project-github-link" target="_blank">
                    Code
                  </a>
                </button>
              </div>
              {/* <h6 className="project-title text-white p-2 text-base">{title}</h6> */}
              <h6 className="project-title text-white p-2 text-base">{title}</h6>

              <p className="project-description p-2 text-sm">{description}</p>
              <div className="project-tech-stack p-2 text-sm">{techStack}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Projects;
